<template>
  <sidebar-default :title="title">
    <b-table id="files-table" striped hover :items="tableItems" :fields="fields">
      <template #cell(type)="data">
        <img :src="require(`@/assets/images/icons/${data.value}`)" alt="Icon">
      </template>

      <template #cell(fileName)="data">
        <p class="title">{{ data.item.title || data.value }}</p>
        <p class="date" v-if="data.item.createDate">{{ data.item.createDate }}</p>
      </template>

      <template #cell(url)="data">
        <a :href="data.value" target="_blank" class="table-download-btn">
          <b-icon icon="download"></b-icon>
        </a>
      </template>
    </b-table>
  </sidebar-default>
</template>

<script>
  // Components
  import SidebarDefault from '@/components/layout/templates/sidebar/SidebarDefault';

  export default {
    name: 'Sidebar',

    props: {
      title: {
        default: 'Files',
        type: String
      },
      items: Array,
      fields: Array,
    },

    components: {SidebarDefault},

    methods: {
      iconsHandler(obj) {
        const type  = obj.type;
        let newType = 'general.png';

        if (type === 'jpg') {
          newType = 'jpg.png'
        } else if (type === 'png') {
          newType = 'png.png'
        } else if (type === 'pdf') {
          newType = 'pdf.png'
        } else if (type === 'docx') {
          newType = 'doc.png'
        }

        obj.type = newType;

        return obj;
      }
    },

    computed: {
      tableItems() {
        const files = this.items;

        files.forEach(this.iconsHandler);

        return files;
      }
    }
  }
</script>

<style scoped lang="scss">
  ::v-deep #files-table {
    width: 100%;
    thead {
      display: none;
    }

    img {
      width: 100%;
      max-width: 40px;
    }

    tr td {
      vertical-align: middle;

      p {
        margin-bottom: 0;

        &.title {
          font-size: 14px;
          font-weight: bold;
        }

        &.date {
          font-size: 10px;
        }
      }
    }

    td:first-child {
      width: 60px;
    }

    td:last-child {
      text-align: right;
    }

    .table-download-btn {
      padding: 5px 10px;
      background-color: #60be6f;
      border-color: #60be6f;
      color: white;
      border-radius: 4px;

      &:hover, &:focus, &:active {
        background-color: #4d9e59 !important;
        border-color: #4d9e59;
      }
    }
  }
</style>
